import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { CodigosModel } from 'src/app/models/codigos.model';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
  selector: 'editar-codigo-reutilizable',
  templateUrl: './editar-codigo-reutilizable.component.html',
  styleUrls: ['./editar-codigo-reutilizable.component.scss']
})
export class EditarCodigoReutilizableComponent implements OnInit {

  public dataTarjetasStickers: CodigosModel[];
  public dataTarjetasStickersTotal: CodigosModel[];
  public parametroTarjetaSticker: string;
  public estado: string;
  public codigosEstado;
  public codigosEstadoSecundaria;
  public estadoCambiado: string;
  public filtroNombre: string;

  public paginas: number[];
  public inicio: number;
  public fin: number;

  public modalOptionsEditar: ConfirmationModalOptions;
  public modalOptionsEditarPDF: ConfirmationModalOptions;

  public generadorPDF: any;
  public p: any;

  constructor(
    private router: Router,
    private global: GlobalService,
    private urlService: UrlService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    public route: ActivatedRoute
  ) {
    this.codigosEstadoSecundaria = [];
  }

  ngOnInit() {
    this.paginas = [];
    this.inicio = 0;
    this.fin = 10;

    this.modalOptionsEditar = new ConfirmationModalOptions(
      'Confirmación',
      ConstantesService.MSJ_CONF_CREAR_CODIGOS_STICKERS,
      'SI', 'NO', 'fa fa-save', true, false, 'Guardar', null, 'btn-secondary');

    this.modalOptionsEditarPDF = new ConfirmationModalOptions(
      'Confirmación',
      ConstantesService.MSJ_CONF_EDITAR_CODIGOS_TARJETAS_CON_PDF,
      'SI', 'NO', 'fa fa-save', true, false, 'Generar PDF Tarjetas', null, 'btn-secondary');

    this.parametroTarjetaSticker = this.global
        .zonaCompartida[VariablesZonaCompartida.TIPO_GENRACION];
    this.obtenerEstados();
  }

  /**
   * Método trae la información de todos los codigos para las tarjetas o para los stickers
   * @function ObtenerTarjetasStickers
   * @return 
   */
  ObtenerTarjetasStickers(event) {
    this.estado = event;
    this.spinner.show();
    const serviceProvider = 'ObtenerTarjetasStickers';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['parametro', this.parametroTarjetaSticker]);
    queryParams.push(['estado', this.estado]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url).subscribe(
      data => {
        this.dataTarjetasStickersTotal = data;
        this.dataTarjetasStickers = this.dataTarjetasStickersTotal;
        this.codigosEstadoSecundaria = [];
        if (this.estado === DominiosService.ESTADO_CODIGO_DISPONIBLE) {
          this.codigosEstadoSecundaria = this.codigosEstado;
        } else if (this.estado === DominiosService.ESTADO_CODIGO_EXTRAVIADO
          || this.estado === DominiosService.ESTADO_CODIGO_INACTIVO) {
          this.codigosEstadoSecundaria = this.codigosEstado.filter(estado => estado.detalleDominioPK.nombreDetalleDominio === this.estado
            || estado.detalleDominioPK.nombreDetalleDominio === DominiosService.ESTADO_CODIGO_DISPONIBLE);
        }
        this.modalOptionsEditar.disabled = true;
        this.modalOptionsEditarPDF.disabled = true;
        this.paginador();
      }, err => {
        this.spinner.hide();
        if (err.status === '500') {
          this.cathException(err.error.message);
        } else {
          this.cathException('No se pudo consultar las tarjetas y stickers');
        }
      });
  }

  /**
   * Método que Consulta los dominios que se relacionen con el nombre 'EstadoCodigo'
   */
  public obtenerEstados() {
    this.spinner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'EstadoCodigo']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.codigosEstado = data.filter(estado => estado.detalleDominioPK.nombreDetalleDominio !== DominiosService.ESTADO_CODIGO_EN_USO);
        this.codigosEstadoSecundaria = this.codigosEstado;
        this.estado = DominiosService.ESTADO_CODIGO_DISPONIBLE;
        this.ObtenerTarjetasStickers(this.estado);
      }, err => {
        this.spinner.hide();
        this.cathException('No es posible obtener los estados');
      }
    );
  }

  ajustarEstado(event, index: number) {
    this.dataTarjetasStickers[index].estado = event;
    this.validarElementosSeleccionados();
  }

 /**
  * * Método que selecciona solo una fila para el cambio de estado
  */
  seleccionarFila(index: number) {
    this.dataTarjetasStickers[index].checked = !this.dataTarjetasStickers[index].checked;
  }

   /**
    * Método que selecciona todas las filas para el cambio de estado
    */
  seleccionarTodo(estado) {
    this.dataTarjetasStickers.forEach(reg => {
      reg.checked = estado;
    });
  }

  /**
   * Método que filtra los elementos de la tabla de acuerdo al valor ingresado en el campo de búsqueda
   * @function buscarPorFiltro
   * @author dfranco@asesoftware.com
   */
  public buscarPorFiltro() {
    if (this.filtroNombre !== undefined && this.filtroNombre !== '') {
      this.dataTarjetasStickers = this.dataTarjetasStickersTotal.filter(
        elemento => elemento.idCodigo.indexOf(this.filtroNombre) !== -1);
      if (this.dataTarjetasStickers.length === 0) {
        const serviceProvider = 'codigos';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=idCodigo', this.filtroNombre]);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
          data => {
            if (data !== undefined && data.length > 0) {
              this.alertService.generateAlertError(
                'El código consultado no se puede modificar desde esta opción, por favor intente nuevamente', '');
            } else {
              this.alertService.generateAlertError(
                'El código ingresado no existe por favor intente nuevamente', '');
            }
          }, err => {
            this.spinner.hide();
            this.cathException('Se presentó un error al consultar el código');
          }
        );
      }
    } else {
      this.dataTarjetasStickers = this.dataTarjetasStickersTotal;
      this.paginador();
    }
  }

  /**
   * Método que permite obtener los elementos que han sido modificados para su edición
   * @function validarElementosSeleccionados
   * @author dfranco@asesoftware.com
   * @returns Lista de objetos modificados
   */
  public validarElementosSeleccionados() {
    const seleccionados: CodigosModel[] = this.dataTarjetasStickersTotal.filter(codigo => codigo.checked === true &&
       codigo.estado !== this.estado);
    if (this.parametroTarjetaSticker === DominiosService.VALOR_TARJETA
      && (this.estado === DominiosService.ESTADO_CODIGO_DISPONIBLE || this.estado === DominiosService.ESTADO_CODIGO_EN_USO)
      || this.parametroTarjetaSticker === DominiosService.VALOR_STICKER) {
      this.modalOptionsEditar.disabled = !(seleccionados.length > 0);
    } else {
      this.modalOptionsEditarPDF.disabled = !(seleccionados.length > 0);
    }
    return seleccionados;
  }

  /**
   * Método que recibe el evento de confirmación de edición de elementos y ejecuta la actualización
   * @function getConfirmationEditar
   * @param event Objeto que contiene la respuesta del usuario (Si o No)
   * @param generarPDF Bandera que indica si se requiere generar un PDF o no
   */
  public getConfirmationEditar(event, generarPDF: boolean) {
    if (event[0]) {
      const seleccionados: CodigosModel[] = this.validarElementosSeleccionados();
      if (seleccionados !== undefined && seleccionados.length > 0) {
        this.guardarCambios(seleccionados, generarPDF);
      }
    }
  }

  /**
   * @param seleccionados
   * @param generarPDF
   */
  public guardarCambios(seleccionados: CodigosModel[], generarPDF: boolean) {
    this.spinner.show();
    let serviceProvider = '';
    if (generarPDF) {
      serviceProvider = 'editarCodigosTarjetasConPDF';
    } else {
      serviceProvider = 'editarCodigosTarjetasStickers';
    }
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url, seleccionados).subscribe(
      data => {
        if (generarPDF) {
          this.generadorPDF = data;
          this.descargarArchivo();
        } else {
          let mensaje = 'Se realizó cambio de estado a códigos de ';
          mensaje += (this.parametroTarjetaSticker === DominiosService.VALOR_TARJETA ? 'tarjeta ' : '');
          mensaje += (this.parametroTarjetaSticker === DominiosService.VALOR_STICKER ? 'sticker ' : '');
          mensaje += 'exitosamente';
          this.alertService.generateAlertSuccess(mensaje, '');
        }
        this.spinner.hide();
        this.ObtenerTarjetasStickers(this.estado);
      }, err => {
        this.spinner.hide();
        this.cathException('No es posible obtener los estados');
      }
    );
  }

  /**
   * Método que convierte el archivo Excel y realiza la descarga del mismo
   * @function descargarArchivo
   * @return
   */
  descargarArchivo() {
    ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      , this.generadorPDF.nombre, this.generadorPDF.archivo);
    this.alertService.generateAlertSuccess('Se cambió estado y se generó PDF exitosamente', '');
  }

  paginador() {
    this.paginas = [];
    this.inicio = 0;
    this.fin = 10;
    if (this.dataTarjetasStickers) {
      const paginaAdicional: boolean = (this.dataTarjetasStickers.length % 10) !== 0;
      let numeroPaginas = Math.round(this.dataTarjetasStickers.length / 10);
      numeroPaginas = paginaAdicional ? numeroPaginas + 1 : numeroPaginas;

      for (let i = 0; i < numeroPaginas; i++) {
        const element = numeroPaginas[i];
        this.paginas.push(element);
      }
    }
    this.spinner.hide();
  }

  cambiarPagina(valor: any) {
    switch (valor) {
      case 'a':
        this.inicio = 0;
        this.fin = 10;
        break;

      case 's':
        const mod = this.dataTarjetasStickers.length % 10;

        if (mod === 0) {
          this.inicio = this.dataTarjetasStickers.length - 10;
        } else {
          this.inicio = this.dataTarjetasStickers.length - mod;
        }
        this.fin = this.dataTarjetasStickers.length;
        break;

      default:
        this.inicio = (valor - 1) * 10;
        this.fin = valor * 10;
        break;

    }
  }

  /**
   * Método que regresa a administrar codigos
   * @function regresarAdministrarCodigo
   * @return
   */
  regresarAdministrarCodigo() {
    this.global.zonaCompartida[VariablesZonaCompartida.TIPO_GENRACION] = undefined;
    this.router.navigate(['/main/administrar-codigos-reutilizable']);
  }

  /**
   * Método de control de Excepciones
   * @function cathException
   * @param  {type} error  mensaje saliente respecto al error ocurrido
   * @return
   */
  cathException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }

}
